// import config from '../config'
// import io from 'socket.io-client'
import axios from '../utils/AxiosInstance'
import Ably from 'ably'

export default {
  // namespaced: true,
  state: {
    socket: {
      isConnected: false
    }
  },
  mutations: {
    SET_CONNECTION_STATUS (state, status) {
      state.socket.isConnected = status
    }
  },
  getters: {
    getSocket: (store, getters) => {
      return store.socket
    }
  },
  actions: {
    socketRecevedMessage ({ commit, dispatch, getters, state }, message) {
      const {
        method,
        entity,
        meta
      } = message

      if (entity === 'activity') {
        dispatch('socketActivity', { method, _id: meta._id, candidateId: meta.candidate_id, jobId: meta.job_id })
      }
      if (entity === 'candidate') {
        dispatch('socketCandidate', { method, _id: meta._id })
      }
      if (entity === 'candidate' && method === 'delete') {
        dispatch('socketCandidateStageBoard', { method, _id: meta._id })
      }
      if (entity === 'placement') {
        dispatch('socketCandidateStageBoard', { method, _id: meta.candidate_id, jobId: meta.job_id })
        dispatch('socketJob', { method: 'update', _id: meta.job_id })
      }
    },
    socketConnect ({ commit, dispatch, getters, state }, accountId) {
      const ably = new Ably.Realtime.Promise({
        echoMessages: false,
        authCallback: (info, callback) => {
          axios.post(`/auth/me/socket-token`, info).then(response => {
            // console.log({ 'socket-token': response.data })
            callback(null, response.data)
          })
        }
      })
      ably.connection.once('connected').then(() => {
        console.log('Connected to Ably!', { channel: accountId })
        const channel = ably.channels.get(accountId)
        channel.subscribe('change-document-message', (message) => {
          dispatch('socketRecevedMessage', message.data)
          console.log('Received message: ', message.data)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Socket.js